.compactField {
  margin-top: 0;
}

.filters {
  align-items: end;
  column-gap: 0.5rem;
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  row-gap: 0.75rem;
}

.updateButton {
  align-self: end;
}

.scoreSummary {
  align-items: flex-start;
  display: flex;
  font-size: 36px;
  gap: 1.5rem;
  justify-content: space-between;
  margin: 0.75em 0 0.5em;
}

.totalScore {
  display: flex;
  justify-content: center;
  margin-left: 1em;
}

.scoreInfo {
  flex: 1 1 0;
  font-size: 18px;
  min-width: 0;
}

.goals > section {
  margin: 0;
  padding: 0;
}

@media (max-width: 900px) {
  .filters {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .scoreSummary {
    flex-direction: column;
  }

  .totalScore {
    margin-left: 0;
  }

  .scoreInfo {
    width: 100%;
  }
}

@media (max-width: 640px) {
  .filters {
    grid-template-columns: 1fr;
  }

  .updateButton {
    width: 100%;
  }
}
